export default "/_next/static/images/Wabisabi-623c31c449d1aee14b1a4affa8c778c5.png";